export const PlanEndpoints = {
  createPlan: 'api/v1/admin/plans/create',
  getAllPlans: 'api/v1/admin/plans/list',
  getPlanDetails: 'api/v1/admin/plans/',
  updatePlan: 'api/v1/admin/plans/',
  deletePlan: 'api/v1/admin/plans/',
  getVendorPlanStatus: 'api/v1/admin/plans/vendor-plan-status/',
  getAllVendorPlans: 'api/v1/admin/plans/vendor-plan/list',
  revokePlan: 'api/v1/admin/plans/revoke-plan',
  assignPlan: 'api/v1/admin/plans/assign-plan'
};